export default __webpack_public_path__ + "static/media/checkbox_tick.1fa8739b.svg";